import React from 'react';

interface StaminaBarProps {
    currentPercent: number;
    drainWidthPercent?: number;
    previewWidthPercent?: number;
    isDraining?: boolean;
    height?: number;
    drainDuration?: number;
    drainRef?: React.RefObject<HTMLDivElement | null>;
}

export const StaminaBar: React.FC<StaminaBarProps> = ({
  currentPercent,
  drainWidthPercent = 0,
  previewWidthPercent = 0,
  isDraining = false,
  height = 12,
  drainDuration = 0.6,
  drainRef,
}) => {
  const fill = Math.max(0, Math.min(100, currentPercent));

  let drainW: number;
  let solidW: number;

  // if (isDraining) {
  //   drainW = Math.max(0, Math.min(fill, drainWidthPercent));
  //   solidW = fill;
  // } else {
  //   drainW = Math.max(0, Math.min(fill, previewWidthPercent));
  //   solidW = fill - drainW;
  // }
  if (isDraining) {
      drainW = Math.max(0, drainWidthPercent); // без Math.min(fill, ...)
      solidW = fill;
  } else {
      drainW = Math.max(0, Math.min(fill, previewWidthPercent));
      solidW = fill - drainW;
  }
  // console.log('[StaminaBar]', { 
  //       currentPercent, 
  //       drainWidthPercent, 
  //       isDraining,
  //       t: performance.now().toFixed(1)
  //   });

  const GRADIENT = 'linear-gradient(to bottom, #e0b85a 0%, #b8862a 50%, #e0b85a 100%)';
  const SHADE    = 'linear-gradient(to bottom, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0) 50%, rgba(255,255,255,0.15) 100%)';

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height,
        borderRadius: 2,
        overflow: 'hidden',
        background: '#151510',
      }}
    >
      {/* Привид — вся поточна стаміна бліда */}
      <div style={{
        position: 'absolute',
        left: 0, top: 0, bottom: 0,
        width: `${fill}%`,
        background: GRADIENT,
        opacity: 0.08,
      }} />

      {/* Суцільна стаміна */}
      <div style={{
        position: 'absolute',
        left: 0, top: 0, bottom: 0,
        width: `${solidW}%`,
        background: GRADIENT,
      }} />

      {/* Drain / Preview */}
      
      {/* Drain */}
<div 
  ref={drainRef}
  style={{
    position: 'absolute',
    left: `${solidW}%`,
    top: 0, bottom: 0,
    width: `${drainW}%`,          // встановлюється один раз, більше не змінюється
    transformOrigin: 'left center',
    background: GRADIENT,
    opacity: isDraining ? 1 : 0.4,
    animation: isDraining
        ? `drainScale ${drainDuration}s ease-out forwards, staminaDrainPulse 1.8s ease-in-out infinite`
        : 'none',
}} />
      

      {/* Shade overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: SHADE,
        pointerEvents: 'none',
      }} />
    </div>
  );
};
